import Api from "@/network/api";
import { httpRequest } from "@/network/request";
import { get, set } from "@/utils/storageHelper";

const ACCOUNT_EVENT_REPORTED_KEY = "AccountEventDataReportedDate";

class UserBiz {
  /**
   * 账号事件数据上报（每天仅请求一次）
   * @param query - 当前页面 URL 的 query 参数对象，全量透传至接口
   */
  reportAccountEventData(query: Record<string, string>): void {
    const today = new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"
    const reportedDate = get<string>(ACCOUNT_EVENT_REPORTED_KEY);

    if (reportedDate === today) {
      return;
    }

    httpRequest({
      apiInfo: Api.AccountEventData,
      params: query,
    })
      .then(() => {
        set(ACCOUNT_EVENT_REPORTED_KEY, today);
      })
      .catch((err) => {
        console.warn("[AccountEventData] 上报失败", err);
      });
  }
}

const userBiz = new UserBiz();
export default userBiz;
